import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/Commission/create.js";
import { bookingApi } from "functions/apis";
import { Redirect } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Check, MailOutline } from "@material-ui/icons";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputLabel,
  MenuItem,
  Select
} from "@material-ui/core";
import AgentDialog from "components/AgentDialog/AgentDialog";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import { tripDateFormat } from "functions/Helper";
import { masterApi } from "functions/apis";
import { creditMonitoringApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function CreateAgentBookingPromoCode(props) {
  const [redirect, setRedirect] = useState(false);
  const [body, setBody] = useState({
    agentID: null,
    promoCode: null,
    effectiveFrom: null,
    effectiveUntil: null,
    discountAmount: null,
    minimumPax: null,
    maximumPax: null,
    onlyForRoundTrip: false,
    hasSectorRestriction: false,
    limit: 0,
    allowedSectorID: null
  });
  const [sectorList, setSectorList] = useState([]);
  const [disabled, setDisabled] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [agent, setAgent] = React.useState(null);
  const [selectedAgentCreditData, setSelectedAgentCreditData] = React.useState(
    null
  );
  const abortController = React.useRef(new AbortController());

  const getSector = () => {
    masterApi
      .get("/Sectors", {
        signal: abortController.current.signal,
        params: {
          pagination: {
            pageIndex: 0,
            pageSize: 0
          },
          filter: {
            searchString: null,
            publicationStatus: 1
          }
        }
      })
      .then(data => {
        setSectorList(data.records);
      })
      .catch(error => console.log(error));
  };

  const handleAgentIDChanged = e => {
    setShowModal(false);
    setAgent(e);
    setBody(prev => ({
      ...prev,
      agentID: e ? e.id : ""
    }));
    creditMonitoringApi
      .get("Agents/" + e.id, {
        signal: abortController.current.signal
      })
      .then(data => setSelectedAgentCreditData(data))
      .catch(() => setSelectedAgentCreditData(null));
  };

  const handlePromoCodeChanged = e => {
    setBody({
      ...body,
      promoCode: e.target.value === "" ? null : e.target.value
    });
  };

  const generateRandomCode = () => {
    const length = 6;
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    setBody(prevBody => ({
      ...prevBody,
      promoCode: result
    }));
  };

  const handleEffectiveFromChanged = e => {
    setBody({ ...body, effectiveFrom: e === "" ? null : e });
  };

  const handleEffectiveUntilChanged = e => {
    setBody({ ...body, effectiveUntil: e === "" ? null : e });
  };

  const handleDiscountAmountChanged = e => {
    setBody({
      ...body,
      discountAmount: e.target.value === "" ? null : e.target.value
    });
  };

  const handleMinimumPaxChanged = e => {
    setBody({
      ...body,
      minimumPax: e.target.value === "" ? null : e.target.value
    });
  };

  const handleMaximumPaxChanged = e => {
    setBody({
      ...body,
      maximumPax: e.target.value === "" ? null : e.target.value
    });
  };

  const handleOnlyForRoundTripChanged = e => {
    setBody({ ...body, onlyForRoundTrip: e.target.checked });
  };

  const handleHasSectorRestrictionChanged = e => {
    setBody({ ...body, hasSectorRestriction: e.target.checked });
  };

  const handleLimitChanged = e => {
    setBody({ ...body, limit: e.target.value });
  };

  const handleAllowedSectorIDChanged = e =>
    setBody({ ...body, allowedSectorID: e.target.value });

  useEffect(() => {
    getSector();
    return () => abortController.current.abort();
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);

    bookingApi
      .post("/AgentBookingPromoCodes", body, {
        signal: abortController.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();

  return redirect ? (
    <Redirect to={"/admin/AgentBookingPromoCodeList"} />
  ) : (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              CREATE AGENT BOOKING PROMO CODES
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form onSubmit={handleSubmit}>
              <GridContainer>
                <GridItem xs={12}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl}
                    onClick={() => (!showModal ? setShowModal(true) : null)}
                    style={{ cursor: "pointer" }}
                  >
                    <InputLabel
                      htmlFor="selAgent"
                      className={classes.selectLabel}
                      style={{ pointerEvents: "none" }}
                    >
                      Agent
                    </InputLabel>

                    <Input
                      className={classes.select}
                      value={agent ? agent.name : ""}
                      disabled
                      style={{ pointerEvents: "none" }}
                    />

                    <AgentDialog
                      openModal={showModal}
                      setOpenModal={val => setShowModal(val)}
                      onSelect={handleAgentIDChanged}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Promo Code"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handlePromoCodeChanged,
                      value: body.promoCode ?? ""
                    }}
                  />
                </GridItem>
                <GridItem xs={6} md={6}>
                  <Button
                    disabled={disabled}
                    color="rose"
                    type="button"
                    value="Generate Random Code"
                    onClick={() => generateRandomCode()}
                  >
                    Generate Random Code
                  </Button>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <InputLabel className={classes.selectLabel}>
                    Effective From
                  </InputLabel>
                  <FormControl fullWidth>
                    <Datetime
                      value={body.effectiveFrom}
                      onChange={handleEffectiveFromChanged}
                      dateFormat={tripDateFormat}
                      timeFormat={true}
                      closeOnSelect={true}
                      inputProps={{
                        placeholder: "Effective From"
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <InputLabel className={classes.selectLabel}>
                    Effective Until
                  </InputLabel>
                  <FormControl fullWidth>
                    <Datetime
                      value={body.effectiveUntil}
                      onChange={handleEffectiveUntilChanged}
                      dateFormat={tripDateFormat}
                      timeFormat={true}
                      closeOnSelect={true}
                      inputProps={{
                        placeholder: "Effective Until"
                      }}
                    />
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Currency"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      disabled: true,
                      value:
                        selectedAgentCreditData === null ||
                        selectedAgentCreditData.billingCurrency === null
                          ? "-"
                          : selectedAgentCreditData.billingCurrency.code
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Discount Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      onChange: handleDiscountAmountChanged,
                      value: body.discountAmount
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Minimum Pax"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      onChange: handleMinimumPaxChanged,
                      value: body.minimumPax
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Maximum Pax"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      onChange: handleMaximumPaxChanged,
                      value: body.maximumPax
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Limit"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      type: "number",
                      onChange: handleLimitChanged,
                      value: body.limit
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={body.onlyForRoundTrip}
                        onChange={handleOnlyForRoundTripChanged}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                      />
                    }
                    classes={{
                      label: classes.label,
                      root: classes.labelRoot
                    }}
                    label="Only For Round Trip"
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={body.hasSectorRestriction}
                        onChange={handleHasSectorRestrictionChanged}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                      />
                    }
                    classes={{
                      label: classes.label,
                      root: classes.labelRoot
                    }}
                    label="Has Sector Restriction"
                  />
                </GridItem>
                {body.hasSectorRestriction && (
                  <GridItem xs={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="selAllowedSectors"
                        className={classes.selectLabel}
                      >
                        Allowed Sectors
                      </InputLabel>
                      <Select
                        inputProps={{
                          id: "selAllowedSectors",
                          name: "selAllowedSectors"
                        }}
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={body.allowedSectorID}
                        onChange={handleAllowedSectorIDChanged}
                      >
                        {sectorList.map(record => {
                          let sector = sectorList.find(
                            item => item.id === record.id
                          );
                          return (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelectedMultiple
                              }}
                              value={record.id}
                              key={record.id}
                            >
                              <b>{sector.code}</b> <br />
                              {sector.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                )}

                <GridItem xs={12} md={12}>
                  <Button
                    disabled={disabled}
                    color="rose"
                    type="submit"
                    value="Submit"
                  >
                    Submit
                  </Button>
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

CreateAgentBookingPromoCode.propTypes = {
  history: PropTypes.object
};
